'use client';

// Global
import React, { useEffect } from 'react';
import { REMIXICON_CONSTANTS } from 'helpers/Constants/SiteConfig';

let spriteInjected = false;

export const RemixSpriteLoader: React.FC = () => {
  useEffect(() => {
    if (spriteInjected) return;
    spriteInjected = true;

    const spriteUrl = REMIXICON_CONSTANTS.spriteImageUrl;

    const loadSprite = async () => {
      try {
        const res = await fetch(spriteUrl, { credentials: 'same-origin' });
        if (!res.ok) return;

        const svgText = await res.text();

        const wrapper = document.createElement('div');
        wrapper.style.position = 'absolute';
        wrapper.style.width = '0';
        wrapper.style.height = '0';
        wrapper.style.overflow = 'hidden';
        wrapper.setAttribute('aria-hidden', 'true');

        wrapper.innerHTML = svgText;

        /*
         * `RemixIconCriticalSprite` already inlines the above-the-fold symbols in the server
         * HTML. Drop those from the fetched sheet so the document does not end up with two
         * elements sharing an id.
         */
        wrapper.querySelectorAll('symbol[id]').forEach((symbol) => {
          if (document.getElementById(symbol.id)) {
            symbol.remove();
          }
        });

        document.body.prepend(wrapper);
      } catch (e) {
        // optional: log error
        console.error('Failed to load RemixIcon sprite', e);
      }
    };

    void loadSprite();
  }, []);

  return null;
};
